const ebooks = state => state.ebooks;
const ebooksDetail = state => state.ebooksDetail;
const ebooksType = state => state.ebooksType;
const ebooksClass = state => state.ebooksClass;
const ebooksFilter = state => state.ebooksFilter;
const allClasses = state => state.allClasses;
const bookRelation = state => state.bookRelation;
const searchResult = state => state.searchResult;
const filters = state => state.filters;
const typeFilters = state => state.typeFilters;
const ebookFAQ = state => state.ebookFAQ;
//const ebooksGroup = state => state.ebooksGroup;


const exerciseDetail = state => state.exerciseDetail;
const question_exercise = state => state.question_exercise;
const question_exercise_info = state => state.question_exercise_info;
const math_value = state => state.math_value;
const open_math = state => state.open_math;
const validate_question = state => state.validate_question;
const question_activity = state => state.question_activity;
const check_answer = state => state.check_answer;
const question_valid_data = state => state.question_valid_data;
const getTraningId = state => state.getTraningId;

export default {
    ebooks,
    ebooksDetail,
    ebooksType,
    ebooksClass,
    ebooksFilter,
    allClasses,
    bookRelation,
    searchResult,
    filters,
    typeFilters,
    ebookFAQ,
    //ebooksGroup,

    exerciseDetail,
    question_exercise,
    question_exercise_info,
    math_value,
    open_math,
    validate_question,
    question_activity,
    check_answer,
    question_valid_data,
    getTraningId,
};